import { useEffect, useState } from "react";

export interface Countdown {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  /** The target has passed (or is missing). */
  done: boolean;
}

export function countdownTo(targetMs: number, nowMs: number): Countdown {
  const left = Math.max(0, targetMs - nowMs);
  const totalSeconds = Math.floor(left / 1000);
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    done: left <= 0,
  };
}

/** Time left until `targetIso`, ticking once a second. */
export function useCountdown(targetIso: string | null | undefined): Countdown {
  const target = targetIso ? Date.parse(targetIso) : NaN;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (Number.isNaN(target)) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);

  if (Number.isNaN(target)) return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
  return countdownTo(target, now);
}
